import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoMontoInversion} from '../_models/producto-monto-inversion';

@Injectable({
  providedIn: 'root'
})
export class ProductoMontoInversionService {
  private rutServicio: string = AppSettings.rutServiciosAPL + "/api/productosMontoInversion";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getAll(): Observable<ProductoMontoInversion[]> {
    return this.httpClient.get<ProductoMontoInversion[]>(this.rutServicio);
  }

  getEnabled(): Observable<ProductoMontoInversion[]> {
    return this.httpClient.get<ProductoMontoInversion[]>(`${this.rutServicio}/enabled}`);
  }

  getById(id: string): Observable<ProductoMontoInversion[]> {
    return this.httpClient.get<ProductoMontoInversion[]>(`${this.rutServicio}/${id}`);
  }

  getByIdProducto(id: string): Observable<ProductoMontoInversion[]> {
    return this.httpClient.get<ProductoMontoInversion[]>(`${this.rutServicio}/producto/${id}`);
  }

  getEnabledByIdProducto(id: string): Observable<ProductoMontoInversion[]> {
    return this.httpClient.get<ProductoMontoInversion[]>(`${this.rutServicio}/producto/${id}/enabled`);
  }

  create(registro: ProductoMontoInversion): Observable<ProductoMontoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoMontoInversion>(this.rutServicio, registro);
  }

  update(registro: ProductoMontoInversion): Observable<ProductoMontoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoMontoInversion>(this.rutServicio, registro);
  }

  bulk(registros: ProductoMontoInversion[]): Observable<ProductoMontoInversion[]> {
    registros.forEach((e: ProductoMontoInversion) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoMontoInversion[]>(`${this.rutServicio}/bulk`, registros);
  }
}
